import { RoleDictionary } from '@/Types/api/Dictionaries';
import { UserRoleEnum } from '@/Types/api/User';

export const getUserRoleDictionaryByRoleEnum = (roles: RoleDictionary[], to: UserRoleEnum): RoleDictionary | undefined => {
    return roles.find((role) => role.key === to);
};
